import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import Axiosfetch from '../Common/Axiosfetch';
import Header from '../Header/AppHeader';
import HighchartsReact from 'highcharts-react-official';
import '../DashBoard/DashboardStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import baseURL from '../Common/Config';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import FailureAlert from '../Common/Failure';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faWallet, faComments, faPercent } from '@fortawesome/free-solid-svg-icons';
import Regions from '../Common/Region';
import Select from 'react-select';

const CustomerDashboard = () => {
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [RegionSymbol, setRegionSymbol] = useState({});
    const [Customers, setCustomers] = useState([]);
    const [QuotationData, setQuotationData] = useState([]);
    const [InvoiceData, setInvoiceData] = useState([]);
    const [ReqAnswered, setReqAnswered] = useState(0);
    const [TotalReq, setTotalReq] = useState(0);
    const [TotalRevenue, setTotalRevenue] = useState(0);
    const [AmountDue, setAmountDue] = useState(0);
    const [DatePeriod, setDatePeriod] = useState("none");
    const [selectedCustomer, setSelectedCustomer] = useState({ value: null, label: null });

    useEffect(() => {
        FetchActiveCustomer();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchActiveCustomer = () => {
        Axiosfetch(baseURL + "GetActiveCustomers", "GET", null, customerDataSuccess, Failure);
    };

    const customerDataSuccess = (data) => {
        var customer = [];
        if (data.length > 0) {
            data.forEach(value => {
                customer.push({ value: value.ID, label: value.Name });
            });
            
            setCustomers(customer);
        }
        else {
            setCustomers([]);
        }
    };

    const onChangeCustomer = (customer) => {
        let customerID = customer ? parseInt(customer.value) : 0;

        setSelectedCustomer({ value: (customer ? customer.value : null), label: (customer ? customer.label : null) });
        if (customerID > 0) {
            var StartDate = moment().startOf('month').format('MM/DD/YYYY, HH:mm:ss');
            var EndDate = moment().endOf('month').format('MM/DD/YYYY, HH:mm:ss');
            FetchCustomerDashboard(customerID, StartDate, EndDate);
        }
        else {
            setQuotationData([]);
            setInvoiceData([]);
            setTotalReq(0);
            setReqAnswered(0);
            setTotalRevenue(0);
            setAmountDue(0);
            setDatePeriod("none");
        }
    }

    const FetchCustomerDashboard = (customerID, start, end) => {
        Axiosfetch(baseURL + "getCustomerDataByCustomerID", "POST", { CustomerID: customerID, StartDate: start, EndDate: end }, CustomerDataSuccess, Failure);
    };

    const CustomerDataSuccess = (data) => {
        let invoiceIDs = [];
        setQuotationData(data.QuotationData);
        setInvoiceData(data.InvoiceData);

        var TotalRequest = 0;
        data.QuotationData.forEach(quotation => {
            TotalRequest += quotation.TotalAmount;
        });

        var RequestComplete = 0;
        data.InvoiceData.forEach(invoice => {
            invoiceIDs.push(invoice.ID);
            let quotationData = data.QuotationData.filter(q => q.ID === invoice.QuotationID);
            if (quotationData.length > 0) {
                RequestComplete += quotationData[0].TotalAmount;
            }
        });

        setTotalReq(TotalRequest);
        setReqAnswered(RequestComplete);
        setTotalRevenue(((RequestComplete / TotalRequest) * 100).toFixed(2));

        Axiosfetch(baseURL + "GetMaxInvoiceNotesByInvoiceID", "POST", { InvoiceIDs: invoiceIDs, }, InvoiceNotesDataSuccess, Failure);

    };

    const InvoiceNotesDataSuccess = (data) => {
        let PaymentDue = 0;
        if (data.length > 0) {
            data.forEach(paymentdue => {
                PaymentDue += paymentdue.Balance;

            })
            setAmountDue(PaymentDue);
        }
        else {
            setAmountDue(0);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const oncheckChange = (type) => {
        if (selectedCustomer.value > 0) {
            setDatePeriod(type);
            let StartDate = (type === "year") ? moment().startOf('year').format('MM/DD/YYYY, HH:mm:ss') :
                ((type === "quarter") ? moment().subtract(3, 'months').startOf('month').format('MM/DD/YYYY, HH:mm:ss') :
                    moment().startOf('month').format('MM/DD/YYYY, HH:mm:ss'))
            let EndDate = moment().endOf('month').format('MM/DD/YYYY, HH:mm:ss');
            FetchCustomerDashboard(selectedCustomer.value, StartDate, EndDate);
        }
        else {
            setDatePeriod("none");
            Alert.error("Please Select Customer", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const options = {
        chart: {
            height: 250,
            width: 400,
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false
        },
        title: {
            text: 'Amount Due / Amount Paid',
            align: 'center',
            verticalAlign: 'middle',
            y: 80,
            style: {
                fontSize: '14px'
            }
        },
        credits: {
            enabled: false
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Amount',
                align: 'high'
            },
            labels: {
                overflow: 'justify'
            }
        },
        xAxis: {
            // categories: [AmountPaid]
        },
        plotOptions: {
            // series: {
            //     borderRadius: 4,
            //     pointWidth: 30
            // }
            pie: {
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '75%']
            }
        },
        series: [
            {
                type: 'pie',
                color: 'green',
                name: 'Paid',
                innerSize: '70%',
                //data: [{ name: 'Paid', y: (ReqAnswered - AmountDue), color: 'green' }],
                data: [{ name: 'Due', y: AmountDue, color: 'red' }, { name: 'Paid', y: (ReqAnswered - AmountDue), color: 'green' }],
                dataLabels: {
                    enabled: true,
                    rotation: 0,
                    align: 'center',
                    format: '{point.y:.2f}',
                    y: 0,
                    style: {
                        fontSize: '11px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            // {
            //     type: 'column',
            //     color: 'red',
            //     name: 'Due',
            //     data: [{ name: 'Due', y: AmountDue, color: 'red' }],
            //     dataLabels: {
            //         enabled: true,
            //         rotation: 0,
            //         align: 'center',
            //         format: '{point.y:.2f}',
            //         y: 0,
            //         style: {
            //             fontSize: '11px',
            //             fontFamily: 'Verdana, sans-serif'
            //         }
            //     }
            // }
        ]
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme cd-background sidemenu-show" style={{ marginBottom: "0.8rem", height: "85vh" }}>
                <div className="row">
                    <div className="offset-md-1 col-md-3 col-sm-3">
                        <div style={{ width: "100%" }}>
                            <Select value={selectedCustomer.value !== null ? selectedCustomer : ''} isClearable={true} isSearchable={true} placeholder="Select Customer"
                                options={Customers}
                                onChange={onChangeCustomer}></Select>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-4 align-center">
                        <h5 style={{ fontWeight: "500" }}>Customer DashBoard</h5>
                    </div>

                    <div className="offset-md-1 col-md-3" style={{ textAlign: "left" }}>
                       <input checked={DatePeriod === "year"} onChange={() => oncheckChange("year")} type="radio"></input><span style={{ padding: "0 10px" }}>Year</span>
                        <input checked={DatePeriod === "quarter"} onChange={() => oncheckChange("quarter")} type="radio"></input><span style={{ padding: "0 10px" }}>Quarter</span>
                        <input checked={DatePeriod === "month"} onChange={() => oncheckChange("month")} type="radio"></input><span style={{ padding: "0 10px" }}>Month</span>
                    </div>
                </div>
                <div className="row" style={{ marginTop: "50px", justifyContent: "space-evenly" }}>
                    <div className="col-md-2 cd-cards2 cd-cardboundry align-center">
                        <div className="row">
                            <div className="col-md-4 col-4" style={{ fontSize: "30px" }}>
                                <FontAwesomeIcon icon={faComments} />
                            </div>
                            <div className="col-md-8 col-8">
                                <span style={{ fontSize: "12px" }}>Total Request</span>
                                <div style={{ fontSize: "18px" }}>
                                    {RegionSymbol.Symbol && (<FontAwesomeIcon className="font-size15rem padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                    {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px" }}>{RegionSymbol.Currency}</div>)}
                                    <span style={{ verticalAlign: "top", paddingLeft: "4px" }}>{TotalReq.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 cd-cards2 cd-cardboundry align-center">
                        <div className="row">
                            <div className="col-md-4 col-4" style={{ fontSize: "30px" }}>
                                <FontAwesomeIcon icon={faThumbsUp} />
                            </div>
                            <div className="col-md-8 col-8">
                                <span style={{ fontSize: "12px" }}>Complete</span>
                                <div style={{ fontSize: "18px" }}>
                                    {RegionSymbol.Symbol && (<FontAwesomeIcon className="font-size15rem padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                    {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px" }}>{RegionSymbol.Currency}</div>)}
                                    <span style={{ verticalAlign: "top", paddingLeft: "4px" }}>{ReqAnswered.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 cd-cards2 cd-cardboundry align-center">
                        <div className="row">
                            <div className="col-md-4 col-4" style={{ fontSize: "30px" }}>
                                <FontAwesomeIcon icon={faPercent} />
                            </div>
                            <div className="col-md-8 col-8">
                                <span style={{ fontSize: "12px" }}>Conversion</span>
                                <div style={{ fontSize: "18px" }}>{TotalRevenue} %</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 cd-cards2 cd-cardboundry align-center">
                        <div className="row">
                            <div className="col-md-4 col-4" style={{ fontSize: "30px" }}>
                                <FontAwesomeIcon icon={faWallet} />
                            </div>
                            <div className="col-md-8 col-8">
                                <span style={{ fontSize: "12px" }}>Amount Due</span>
                                <div style={{ fontSize: "18px" }}>
                                    {RegionSymbol.Symbol && (<FontAwesomeIcon className="font-size15rem padding-topLeft" icon={RegionSymbol.Symbol}></FontAwesomeIcon>)}
                                    {RegionSymbol.Symbol === null && (<div style={{ padding: "5px 0 0 10px" }}>{RegionSymbol.Currency}</div>)}
                                    <span style={{ verticalAlign: "top", paddingLeft: "4px" }}>{AmountDue.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: "20px" }}>
                    <div className="offset-md-1 col-md-6" style={{
                        backgroundColor: "white",
                        border: "1px solid #ccc", height: "40vh", overflow: "auto"
                    }}>
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th className={`align-center`}>Invoice #</th>
                                    <th className={`align-center`}>Amount</th>
                                    <th className={`align-center`}>Create Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {InvoiceData.length > 0 && InvoiceData.map(invoice => (
                                    <tr className="textCenter">
                                        <td>{invoice.ID}</td>
                                        <td>{QuotationData.filter(q => q.ID === invoice.QuotationID).length > 0 &&
                                            QuotationData.filter(q => q.ID === invoice.QuotationID)[0].TotalAmount}</td>
                                        <td>{moment(invoice.CreatedDate).local().format("DD MMMM YYYY hh:mm:ss A")}</td>
                                    </tr>
                                ))}
                                {InvoiceData.length === 0 && (
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: "center" }}>No Invoice Data</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-4">
                        <div style={{ borderRadius: "6px", backgroundColor: "white", border: "1px solid #ccc", height: "40vh" }}>
                            {QuotationData.length > 0 && InvoiceData.length > 0 && selectedCustomer.value !== null && (<HighchartsReact highcharts={Highcharts} options={options}></HighchartsReact>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerDashboard;